/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Timeline(theme: Theme): any {
  return {
    MuiTimelineDot: { styleOverrides: { root: { boxShadow: "none" } } },

    MuiTimelineConnector: { styleOverrides: { root: { backgroundColor: theme.palette.divider } } },
  };
}
